import { queryOptions } from '@tanstack/react-query';
import { getPendingApprovals } from './pending-approvals.api';
import { TOOL_APPROVAL_QUERY_KEYS } from './query-keys';

/** The tool calls a conversation's last turn paused on. */
export const pendingApprovalsQueryOptions = (contextId: string) =>
  queryOptions({
    queryKey: TOOL_APPROVAL_QUERY_KEYS.pending(contextId),
    queryFn: () => getPendingApprovals(contextId),
    // Any turn can pause or answer, so the list is read again whenever it is asked for once more
    // (a turn ending re-enables it), rather than kept for the app's usual five minutes.
    staleTime: 0,
  });
